import { complexityTooltip, contentStatusNumber } from '../../constants';
import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { formatDateTimestampNumber } from 'utils/formatDateTimestampNumber';

const { parse } = require('json2csv');

const handleDownloadTaskCSV = async (accountId) => {
  const firebaseHelper = getFirebaseBackend();

  try {
    const response = await firebaseHelper.getAllTasks(accountId);
    const allTasks = Object.values(response);

    const tasksPromises = allTasks.map(async (task) => {
      let assignedToNames = '';

      if (task.assignedTo && task.assignedTo.length > 0) {
        const userPromises = task.assignedTo.map(
          async (userId) => await firebaseHelper.getUserName(userId),
        );
        const resolvedUserNames = await Promise.all(userPromises);
        assignedToNames = resolvedUserNames.join(',');
      }

      return {
        Column: task.column,
        Name: task.name,
        AssignedTo: assignedToNames,
        Complexity: task.complexity ? complexityTooltip[task.complexity] : '',
        CreatedAt: task.createdAt ? new Date(task.createdAt).toISOString().substring(0, 10) : '',
        Foundations: task.foundations ? task.foundations.join(',') : '',
        HasChecklist: task.hasChecklist,
        Impact: task.impact ? complexityTooltip[task.impact] : '',
        Status: task.status ? contentStatusNumber[task.status] : '',
        DeliveryDate: formatDateTimestampNumber(task.dateDelivery, 'date-enUS'),
        ImplementationDate: formatDateTimestampNumber(task.dateImplementation, 'date-enUS'),
        Description: task.description,
      };
    });

    const resolvedTasks = await Promise.all(tasksPromises);

    const csvOptions = {
      fields: [
        'Column',
        'Name',
        'AssignedTo',
        'Complexity',
        'CreatedAt',
        'Foundations',
        'HasChecklist',
        'Impact',
        'Status',
        'DeliveryDate',
        'ImplementationDate',
        'Description',
      ],
      header: true,
    };

    const csvContent = parse(resolvedTasks, csvOptions);

    const blob = new Blob([csvContent], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const accountName = await firebaseHelper.accountName(accountId);
    const dateNumber = new Date().toISOString().substring(0, 10);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${accountName}_${dateNumber}_tasks_data.csv`;

    link.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading CSV:', error);
  }
};

export { handleDownloadTaskCSV };
